import merge from 'lodash/merge';

import { Util } from '@baifendian/adhere';

import reactPro from '@/components/system/SystemTheme/theme/eVisa/reactPro';
import Config from '@/lib/config';

import _token from './token';

export default media => {
  const base = reactPro(media);

  const _tokenMap = _token(media);

  return merge(base, {
    components: {
      SystemBaseSearchTable: {
        isUsePadding: true,
        isUseRadius: false,
        isUseSearchWrapperGap: false,
        isUseSearchFormToolBarGap: false,
      },
      SystemPage: {
        backgroundColor: '#fff',
      },
      SystemHeader: {
        menuMenuTabsAntTabsTabBtnFirstChildColor: '#fff',
        menuMenuTabsActiveAntTabsTabBtnFirstChildColor: '#fff',
        menuMenuTabsAntTabsTabBtnPadding: `0 ${Util.pxToRem(10, media.designWidth, media)}`,
        menuMenuTabsAntTabsTabBtnBorderRadius: `${Util.pxToRem(4, media.designWidth, media)}`,
        menuMenuTabsActiveAntTabsTabBtnBackgroundColor: _tokenMap.get(
          'common-primary-color'
        ).value,
        horizontalHeight: `${Util.pxToRem(92, media.designWidth, media)}`,
        horizontalLogoWrapTitleColor: '#fff',
        actionsUserInfoColor: '#fff',
        actionsLogOutColor: '#fff',
        actionsSeparationColor: '#fff',
        actionsUserIconColor: '#fff',
      },
      SystemLangChangeWithDark: {
        backgroundColor: 'transparent',
      },
      SystemLangChange: {
        iconColor: '#fff',
      },
      SystemDirectionChange: {
        imgColor: '#fff',
      },
      SystemCard: {
        border: '1px solid #dfdfdf',
        headTitleFontSize: `${Util.pxToRem(16, media.designWidth, media)}`,
      },
    },
    'form-item': {},
    lib: {
      BasicLayout: {
        antMenuSubmenuTitleContentFontSize: `${Util.pxToRem(13, media.designWidth, media)}`,
        antMenuSubmenuTitleContentLineHeight: `${Util.pxToRem(22, media.designWidth, media)}`,
        antMenuInlineBackground: 'transparent',
        antMenuItemSelectedBackgroundColor: 'transparent',
        antMenuItemSelectedTitleContentPadding: `${Util.pxToRem(8, media.designWidth, media)} ${Util.pxToRem(12, media.designWidth, media)}`,
        antMenuItemSelectedTitleContentColor: _tokenMap.get(
          'common-primary-color'
        ).value,
        antMenuItemSelectedTitleContentBackground: `
        linear-gradient(
          270deg,
          rgba(240, 189, 100, 0) 0%,
          #f0bd64 100%
        )
      `,
        antMenuItemSelectedTitleContentBorderRadius: `${Util.pxToRem(18, media.designWidth, media)} 0 0 ${Util.pxToRem(18, media.designWidth, media)}`,
        menuIconTextFontSize: `${Util.pxToRem(12, media.designWidth, media)}`,
        menuIconTextLineHeight: `${Util.pxToRem(18, media.designWidth, media)}`,
        antMenuItemTitleContentFontSize: `${Util.pxToRem(13, media.designWidth, media)}`,
        antMenuItemTitleContentLineHeight: `${Util.pxToRem(22, media.designWidth, media)}`,
        antMenuItemOnlyChildMenuIconTextPaddingLeft: 0,
        sliderMenuBarTriggerColor: '#9EC0D9',
        antMenuSubmenuTitleContentColor: '#9EC0D9',
        antMenuSubmenuArrowBeforeColor: '#9EC0D9',
        antMenuSubmenuArrowAfterColor: '#9EC0D9',
        menuTitleIconColor: '#9EC0D9',
        menuIconTextColor: '#fff',
        antMenuItemTitleContentColor: '#9EC0D9',
        sliderDarkBackgroundColor: 'transparent',
        borderRadius: `${Util.pxToRem(16, media.designWidth, media)}`,
        mainWrapperBackgroundColor: 'rgba(255,255,255,0.9)',
        mainWrapperPadding: `0 ${Util.pxToRem(25, media.designWidth, media)} ${Util.pxToRem(25, media.designWidth, media)} ${Util.pxToRem(25, media.designWidth, media)}`,
        sliderBackgroundColor: `
          linear-gradient(
            180deg,
            rgba(33, 55, 73, 0.8) 0%,
            rgba(29, 43, 54, 0.8) 100%
          )
        `,
      },
    },
    app: {
      background: `url('${Config.bgPath}') lightgray 50% / cover no-repeat`,
      verticalBodyPadding: `0 ${Util.pxToRem(24, media.designWidth, media)} ${Util.pxToRem(24, media.designWidth, media)} ${Util.pxToRem(24, media.designWidth, media)}`,
      logoImgWidth: 'auto',
      logoImgHeight: 64,
    },
    appComponents: {},
    appLib: {},
    'app-form-item': {},
    pages: {},
  });
};
